<h1>{{ "GENERAL.OVERVIEW" | appString }} - {{ "GENERAL.SECTION" | appString }} {{this.model().section.name}}</h1>
<div>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource()" matSort>
<!-- header begins -->
      <ng-container matColumnDef="{{HEADER_COLUMN_INSERTION_BATCH}}">
        <th mat-header-cell class="border-r-3 font-bold" *matHeaderCellDef>
        </th>
      </ng-container>
      <ng-container matColumnDef="{{HEADER_COLUMN_INSERTION}}">
        <th mat-header-cell class="text-xl font-bold text-center border-r-3" *matHeaderCellDef
          [attr.colspan]="2">
            {{this.model().firstInsertionDate() | date: 'dd.MM.yy'}} <br>
            {{ "GENERAL.INITIAL" | appString }}
        </th>
      </ng-container>
      @for (interimNumber of ([].constructor(this.model().maxInterimNumber())).keys(); track $index) {
        <ng-container matColumnDef="{{HEADER_COLUMN_INTERIM_WEIGHING}}{{$index+1}}">
          <th class="text-xl font-bold text-center border-r-3" mat-header-cell *matHeaderCellDef
            [attr.colspan]="2">
              {{ this.model().getInterimDate($index + 1) | date: 'dd.MM.yy HH:mm'}} <br>
              {{ $index + 1}}. {{ "GENERAL.INTERIMWEIGHING" | appString }}
          </th>
        </ng-container>
      }
      <ng-container matColumnDef="{{HEADER_COLUMN_END_WEIGHING}}">
        <th class="text-xl font-bold text-center" mat-header-cell *matHeaderCellDef
          [attr.colspan]="2">
            {{ "GENERAL.FINALWEIGHING" | appString }}
        </th>
      </ng-container>
<!-- header ends -->
<!-- rows begin -->
      <ng-container matColumnDef="{{COLUMN_INSERTION_BATCH}}">
        <th mat-header-cell *matHeaderCellDef class="border-r-3 text-xl font-bold text-center">
          {{ "GENERAL.BATCH" | appString }}
        </th>
        <td class="registration-approved-status border-r-3 text-xl text-center" mat-cell *matCellDef="let row">
          {{row.batchNumber}}
        </td>
      </ng-container>

      <ng-container matColumnDef="{{COLUMN_INSERTION_SEX}}">
        <th mat-header-cell class="text-xl font-bold text-center" *matHeaderCellDef> {{ "GENERAL.GENDER" | appString }} </th>
        <td
          class="text-xl text-center"
          [ngClass]="getRowClassForInsertion(row)" mat-cell *matCellDef="let row"
          (click)="clickBatchWeighing(row.getInitial())">
            {{ row.getInitial()?.gender?.name }}
          </td>
      </ng-container>

      <ng-container matColumnDef="{{COLUMN_INSERTION_AVG_WEIGHT}}">
        <th mat-header-cell *matHeaderCellDef class="text-xl font-bold text-center border-r-3"> {{ "GENERAL.AVERAGEWEIGHTSHORT" | appString }} </th>
        <td
          class="border-r-3 text-xl text-center"
          [ngClass]="getRowClassForInsertion(row)" mat-cell *matCellDef="let row"
          (click)="clickBatchWeighing(row.getInitial())">
          {{ formatAverageWeight(row.getInitial()?.averageWeight) }}
          <approve-reject-reg
            [viewModel]="createViewModelForApproveRejectRegComponent(row.getInitial())"
            (click)="clickApproveReject(row.getInitial()?.weighingType, $event)"/>
        </td>
      </ng-container>

      @for (interimNumber of ([].constructor(this.model().maxInterimNumber())).keys(); track $index) {
        <ng-container matColumnDef="{{COLUMN_WEIGHING_DATE}}{{$index + 1}}">
          <th mat-header-cell *matHeaderCellDef class="text-xl font-bold text-center"> {{ "GENERAL.DATE" | appString }} </th>
          <td
            class="text-xl text-center"
            [ngClass]="getRowClassForInterimWeighingDate(row, $index + 1)"
            mat-cell *matCellDef="let row"
            (click)="clickBatchWeighing(row.getInterimByOrder($index + 1))">
              {{row.getInterimByOrder($index +1)?.date | date: 'dd.MM.yy'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="{{COLUMN_WEIGHING_AVG_WEIGHT}}{{$index + 1}}">
          <th mat-header-cell *matHeaderCellDef class="text-xl font-bold text-center border-r-3"> {{ "GENERAL.AVERAGEWEIGHTSHORT" | appString }} </th>
          <td
            class="text-xl text-center border-r-3"
            [ngClass]="getRowClassForInterimWeighingAvgWeight(row, $index + 1)"
            mat-cell *matCellDef="let row"
            (click)="clickBatchWeighing(row.getInterimByOrder($index + 1))">
            @if (row.getInterimByOrder($index + 1)) {
              <approve-reject-reg
                [viewModel]="createViewModelForApproveRejectRegComponent(row.getInterimByOrder($index + 1))"
                (click)="clickApproveReject(row.getInterimByOrder($index + 1)?.weighingType, $event)"/>
            }
          </td>
        </ng-container>
      }

      <ng-container matColumnDef="{{COLUMN_END_WEIGHING_DATE}}">
        <th mat-header-cell *matHeaderCellDef class="text-xl font-bold text-center"> {{ "GENERAL.DATE" | appString }} </th>
        <td
          class="text-xl text-center"
          [ngClass]="getRowClassForEndWeighingDate(row)"
          mat-cell *matCellDef="let row"
          (click)="clickBatchWeighing(row.getFinal())">
            {{ row.getFinal()?.date | date: 'dd.MM.yy HH:mm'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="{{COLUMN_END_WEIGHING_AVG_WEIGHT}}">
        <th mat-header-cell *matHeaderCellDef class="text-xl font-bold text-center"> {{ "GENERAL.AVERAGEWEIGHTSHORT" | appString }} </th>
        <td
          class="text-xl text-center"
          [ngClass]="getRowClassForEndWeighingAvgWeight(row)" mat-cell *matCellDef="let row"
          (click)="clickBatchWeighing(row.getFinal())">
          @if (row.getFinal()) {
            <approve-reject-reg
              [viewModel]="createViewModelForApproveRejectRegComponent(row.getFinal())"
              (click)="clickApproveReject(row.getFinal()?.weighingType, $event)"/>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedHeaderColumns()"></tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
      <tr mat-row attr.batch-id={{row.batchId.asString()}} *matRowDef="let row; columns: displayedColumns();"></tr>
    </table>

  </div>
</div>

